<template>
  <router-view />
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import communicationService from '@/services/communicationService'
  export default {
    name: 'App',
    computed: {
      ...mapState({
        AuthenticationToken: state => state.security.user.access_token,
      }),
      ...mapGetters(['userHasAccess']),
    },
    watch: {
      AuthenticationToken (to, from) {
        if (to !== from) {
          // disconnect from all hubs to make sure we only have hubs active we allowed to be connected to
          communicationService.disconnectFromHubs()

          if (this.userHasAccess('operatorAdmin') === true) {
            // todo connect to operatorHub
          }

          // for now all authorized users can connect to the reseller hub
          communicationService.connectToResellerHub()
        }
      },
    },
  }
</script>
